import React from 'react';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { volumes } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Volumes() {
  return <section className="w-full bg-sand px-4 py-14 sm:px-6 sm:py-20" data-id="element-282" data-mp="2x19y6o5r6ses">
      <div className="mx-auto max-w-4xl" data-id="element-283" data-mp="2x3cvlt98jntj">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-284" data-mp="2t07vfxcmny82">
          Cosa troverai all’interno
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-285" data-mp="2o1wlznq8vpqd">
          La biblioteca clinica in 6 volumi
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-286" data-mp="2ebtsznj4ibs1">
          Un sistema visivo completo che ti accompagna attraverso le principali fasi della pianificazione dei
          trattamenti con allineatori.
        </p>

        <div className="mt-9 space-y-4" data-id="element-287" data-mp="20b0zn64k5mqi">
          {volumes.map(volume => <article key={volume.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_10px_24px_-16px_rgba(15,37,71,0.35)]" data-id="element-288" data-mp="20ddbr2nmx2vn">
              <div className="h-1.5 w-full" style={{
            backgroundColor: volume.accent
          }} aria-hidden="true" data-id="element-289" data-mp="37xnn8lx9ns7d" />
              <div className="p-5 sm:p-6" data-id="element-290" data-mp="2u2uzx1b4x7q8">
                <div className="flex items-center gap-2.5" data-id="element-291" data-mp="2y61gp2vvihay">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl" style={{
                backgroundColor: `${volume.accent}1a`
              }} data-id="element-292" data-mp="2y4gmjedh10dm">
                    <BookOpenIcon className="h-4 w-4" style={{
                  color: volume.accent
                }} aria-hidden="true" data-id="element-293" data-mp="3qt48lc61nts8" />
                  </span>
                  <span className="text-[11px] font-extrabold uppercase tracking-[0.16em]" style={{
                color: volume.accent
              }} data-id="element-294" data-mp="3hu0rgdqftogd">
                    {volume.number}
                  </span>
                </div>

                <h3 className="mt-3 font-display text-[21px] font-bold leading-snug text-navy sm:text-2xl" data-id="element-295" data-mp="26daiwnyjkkjl">
                  {volume.title}
                </h3>
                <p className="mt-2.5 text-[14px] font-semibold leading-relaxed text-navy/85 sm:text-[15px]" data-id="element-296" data-mp="71d6vq4b8qm4">
                  {volume.lead}
                </p>
                <p className="mt-2 text-[14px] leading-relaxed text-navy/65" data-id="element-297" data-mp="3ude610ueivgc">{volume.body}</p>

                <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.16em] text-navy/40" data-id="element-298" data-mp="3pe1i0crsnic6">All’interno</p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-299" data-mp="3kef6q8vj0c60">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2 text-[13.5px] leading-snug text-navy/80" data-id="element-300" data-mp="3fgwwmf5rvqwf">
                      <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-301" data-mp="3bflesvt549ys" />
                      <span data-id="element-302" data-mp="1dn7bbhdp3gpf">{item}</span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <CtaBlock className="mt-9" label="Ottieni tutti e 6 i volumi per €19" data-id="element-303" data-mp="2rlbpp82zqptw" />
      </div>
    </section>;
}